import { ReactElement } from 'react'
import Drawer from '../drawer/Drawer'
import { CallInfo } from './CallInfo'
import type { CallJson } from 'app/types/entities'
import type { LocationType } from 'app/types/entities'

type CallDrawerProps = {
  call: CallJson
  location?: LocationType
  open: boolean
  onCallUpdate: (call: CallJson) => void
  onClose: () => void
}

export function CallDrawer({ call, location, open, onCallUpdate, onClose }: CallDrawerProps): ReactElement {
  return (
    <Drawer
      open={open}
      onClose={onClose}
      canExpand={false}
      leftContent={<CallInfo call={call} location={location} onCallUpdate={onCallUpdate} />}
      // footerSlot={<CallFooter call={call} />}
    />
  )
}
